import {
  Box, Theme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PayoutDialogContentType } from '../../../common/enums';
import { TestIds } from '../../../assets/testIds';
import { PayoutCTA, GoBackLink } from './Common';

type ActivePaymentMethodConfirmProps = {
  onConfirmActiveClick?: () => void;
  setDialogContentType?: (event: PayoutDialogContentType) => void;
  setDialogSubTitle?: (event: string | JSX.Element) => void;
};

export function ActivePaymentMethodConfirm({
  onConfirmActiveClick,
  setDialogContentType,
  setDialogSubTitle,
}: ActivePaymentMethodConfirmProps) {
  const { t } = useTranslation();
  return (
    <Box
      sx={(theme: Theme) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        gap: theme.spacing(1),
        alignSelf: 'stretch',
        maxWidth: 'sm',
      })}
    >
      <PayoutCTA text={`${t('button.confirmChange')}`}
        data-testid={TestIds.managePayoutSettings.confirmActiveBtn}
        onClick={onConfirmActiveClick}
      />
      <Box
        sx={{
          alignSelf: 'center',
        }}
      >
        <GoBackLink
          data-testid={TestIds.managePayoutSettings.goBackBtn}
          setDialogContentType={setDialogContentType}
          setDialogSubTitle={setDialogSubTitle}
        />
      </Box>
    </Box>
  );
}
